module.exports = __webpack_public_path__ + "img/s_1.a911800a.png";